import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=096a4b24&scoped=true&"
import script from "./Setting.vue?vue&type=script&lang=ts&"
export * from "./Setting.vue?vue&type=script&lang=ts&"
import style0 from "./Setting.vue?vue&type=style&index=0&id=096a4b24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096a4b24",
  null
  
)

export default component.exports